const common = {
  Loading: "Cargando",
  signUp: "Inscríbete",
  login: "Iniciar sesión",
  logout: "Cierre de sesión",
  email: "Correo electrónico",
  emailFormatErrorTips: "El formato del correo electrónico es incorrecto",
  emailDifferentTips: "Por favor, introduzca el mismo correo electrónico en ambos campos.",
  emailRegisteredTips: "Este E-mail ha sido registrado, por favor elija otro.",
  password: "Contraseña",
  passwordFormatErrorTips:
    "La contraseña debe tener entre 8 y 50 caracteres y contener al menos dos categorías entre las siguientes: número, letra o carácter especial.",
  passwordDifferentTips: "Por favor, introduzca la misma contraseña en ambos campos.",
  verificationCode: "Código de verificación",
  verificationCodeErrorTips: "Código de verificación incorrecto",
  confirm: "Confirmar",
  cancel: "Cancelar",
  submit: "Enviar",
  confirmEmail: "Confirmar correo electrónico",
  formEmptyErrorTips: "No puede estar vacío aquí.",
  country: "País/Región",
  birthday: "Cumpleaños",
  anonymous: "Anónimo",
  name: "Nombre",
  nameFormatErrorTips: "El nombre de usuario debe tener menos de 50 caracteres y no contener caracteres especiales",
  okBtn: "OK",
  serverErrorTips: "Disculpe, algo salió mal, por favor intente de nuevo más tarde",
  updateSuccessTips: "Lo ha cambiado con éxito",
  authorizationExpiredErrorTips: "La autorización ha caducado, por favor vuelva a iniciar sesión",
  requestFrequentlyErrorTips: "Se realizaron demasiados pedidos en poco tiempo, intente de nuevo más tarde",
};

export default common;
